// eslint-disable-next-line
export enum FormCommunication {
  name = 'name',
  chanel = 'chanel',
  city = 'city',
  country = 'country',
  radius = 'radius',
  type_communication = 'type_communication',
  template = 'template',
  messages = 'messages',
  events = 'events',
  messageAmount = 'messageAmount',
}

export interface CheckBoxData {
  checked: boolean;
  id: string;
  name: string;
}
